import { render, staticRenderFns } from "./bankCutPaymentDetail.vue?vue&type=template&id=504d8906&scoped=true&"
import script from "./bankCutPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./bankCutPaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./bankCutPaymentDetail.vue?vue&type=style&index=0&id=504d8906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504d8906",
  null
  
)

export default component.exports